import { render, staticRenderFns } from "./GroupSelectorNeo.vue?vue&type=template&id=958a71b4&scoped=true&"
import script from "./GroupSelectorNeo.vue?vue&type=script&lang=js&"
export * from "./GroupSelectorNeo.vue?vue&type=script&lang=js&"
import style0 from "./GroupSelectorNeo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GroupSelectorNeo.vue?vue&type=style&index=1&id=958a71b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958a71b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VChip,VChipGroup,VIcon,VList,VListItem,VListItemTitle,VMenu})
